import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IBulkPatientRes,IAddBulkPatientReq } from './index.type';


const useAddBulkPatient = () => {
  
  const url = `/users/Add-bulk-PatientByAssociate`;
  const method = 'POST';
  const headerContentType = "multipart/form-data"

  const { loading: addBulkPatientLoading, makeApiCall } = useApi({ url, method,headerContentType });

  const  addBulkPatient = async (formData:IAddBulkPatientReq) => {
    const { response, error } = await makeApiCall<IAddBulkPatientReq ,IBulkPatientRes>(formData);
    if (response?.status === 'success') {
     toast.success('Patient File Added Successfully');
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to add patients in bulk. Please check the data and try again.');
      return { status: 'fail' };
    }
  };

  return {
    addBulkPatientLoading,
    addBulkPatient,
  };
};

export default useAddBulkPatient;
